import { render, staticRenderFns } from "./Admissions.vue?vue&type=template&id=1e9482f0"
import script from "./Admissions.vue?vue&type=script&lang=js"
export * from "./Admissions.vue?vue&type=script&lang=js"
import style0 from "./Admissions.vue?vue&type=style&index=0&id=1e9482f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports